import { useRef, useState, useEffect } from "react";
import useAuth from "../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import useInput from "../hooks/useInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faEye,faEyeSlash} from "@fortawesome/free-solid-svg-icons"
import "../style/login.css";

import axios from "../api/axios";
const LOGIN_URL = "/auth";

const Login = () => {
  const { setAuth } = useAuth();

  const navigate = useNavigate();

  const userRef = useRef();
  const errRef = useRef();

  const [user, resetUser, userAttribs] = useInput("user", "");
  const [pwd, setPwd] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [hidden, setHidden] = useState(true);

  useEffect(() => {
    userRef.current.focus();
  }, []);

  useEffect(() => {
    setErrMsg("");
  }, [user, pwd]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        LOGIN_URL,
        JSON.stringify({ user, pwd }),
        {
          headers: { "Content-Type": "application/json" },
          
        }
      );
      const accessToken = response?.data?.accessToken;
      localStorage.setItem("token", JSON.stringify(accessToken));
      localStorage.setItem("company",JSON.stringify(response?.data?.company))
      const roles = response?.data?.roles;
      setAuth({ user, pwd, roles, accessToken });
      resetUser();
      setPwd("");
      const routes = {
        2001: "/",
        1984: "/moderator",
        5150: "/admin",
      };
      const redirect = routes[roles[0]];
      navigate(redirect, { replace: true });
    } catch (err) {
      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.status === 400) {
        setErrMsg("Missing Username or Password");
      } else if (err.response?.status === 401) {
        setErrMsg("Unauthorized");
      } else {
        setErrMsg("Login Failed");
      }
      errRef.current.focus();
    }
  };

  return (
    <section>
      <p
        ref={errRef}
        className={errMsg ? "errmsg" : "offscreen"}
        aria-live="assertive"
      >
        {errMsg}
      </p>
      <h4 className="text-center">Iniciar sesión</h4>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <input
            type="text"
            id="username"
            placeholder="Nombre de usuario"
            className="form-control"
            ref={userRef}
            autoComplete="off"
            {...userAttribs}
            required
          />
        </div>

        <div className="input-group mb-3">
          <input
            type={hidden ? "password" : "text"}
            className="form-control"
            id="password"
            placeholder="Contraseña"
            onChange={(e) => setPwd(e.target.value)}
            value={pwd}
            required
          />
          <button
            className="btn btn-outline-secondary"
            type="button"
            onClick={()=>setHidden(!hidden)}
          >
          <FontAwesomeIcon icon={hidden ? faEye : faEyeSlash} style={{width: "16px", height: "16px"}}/>
          </button>
        </div>

        <button className="btn btn-lg btn-success btn-block" type="submit">
          Login
        </button>
        <p className="mt-5 mb-3 text-muted">
          Developed by MSK Sistemas © 2021-2022
        </p>
      </form>
    </section>
  );
};

export default Login;
